import InsightsAgenda from './InsightsAgenda';

export { type InsightsAgendaProps } from './InsightsAgenda';
export default InsightsAgenda;
